import React, { useState, useEffect, useContext, useRef } from 'react';
import { LoginContext } from '../Login/LoginContext';
import {
  FaBars, FaTachometerAlt, FaUsers, FaUser, FaUserPlus,FaTrain, FaShareAlt, FaPeace, FaMobileAlt, FaMailBulk, FaCloudDownloadAlt, FaFileContract, FaChartLine, FaUserTie
} from 'react-icons/fa'; // Added FaFileContract, FaChartLine, FaUserTie for better icon matching
import { Outlet, NavLink } from 'react-router-dom';
import './Sidebar.css';
import { useNavigate } from 'react-router-dom';

export default function Sidebar() {
  const { loginResult, logout } = useContext(LoginContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? JSON.parse(saved) : window.innerWidth > 768;
  });

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) setSidebarOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem('sidebarOpen', JSON.stringify(sidebarOpen));
  }, [sidebarOpen]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  const toggleDropdown = () => setDropdownOpen(prev => !prev);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  }; const downloadapk = () => {
    navigate('Apk');
    setDropdownOpen(false);
  }

  return (
    <div className="layout">
      <div className="topbar">
        <div className="topbar-left">
          <img src="/images/auditlogo.png" alt="Logo" className="Side_logo" />
          <FaBars className="menu-icon" onClick={toggleSidebar} />
        </div>
        <div className="topbar-right" ref={dropdownRef}>
          <FaUser className="user-icon" onClick={toggleDropdown} />
          {dropdownOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-item">
                <FaPeace /> <strong>{loginResult?.Name || 'User Name'}</strong>
              </div>
              <div className="dropdown-item">
                <FaMobileAlt /> {loginResult?.Mobilenumber || 'Mobile Number'}
              </div>
              <div className="dropdown-item">
                <FaMailBulk /> {loginResult?.email || 'Mobile Number'}
              </div>
              <div className="dropdown-item" onClick={downloadapk}>
                <FaCloudDownloadAlt /> Download Mobile App
              </div>
              <hr />
              <button className="dropdown-item logout-btn" onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>
      </div>

      <div className="main-section">
        <div className={`sidebar ${sidebarOpen ? 'open' : 'closed'} ${isMobile && sidebarOpen ? 'mobile-open' : ''}`}>
          <ul>
            <li onClick={() => {
              setSidebarOpen(false);
              if (loginResult?.user_type === 'team_head') {
                navigate('Dashboard');
              } else if (loginResult?.user_type === 'team_member') {
                navigate('Dashboard_user');
              }
            }}>
              <FaTachometerAlt /><span>Dashboard</span>
            </li>
            <NavLink onClick={() => setSidebarOpen(false)} to="Managelead" ><li><FaUsers /><span>Manage Leads</span></li></NavLink>
            
            <NavLink className="addlead" onClick={() => setSidebarOpen(false)} to="Addlead"><li><FaUserPlus /><span>Add Lead</span></li></NavLink>

            {loginResult?.user_type === 'team_head' && (
              <>
                <NavLink onClick={() => setSidebarOpen(false)} to="Lead_head"><li><FaShareAlt /><span>Lead Distribution</span></li></NavLink> {/* Changed text to Lead Distribution for clarity */}
              </>
            )}
            <NavLink onClick={() => setSidebarOpen(false)} to="Reportsview"><li><FaChartLine /><span>Reports</span></li></NavLink> {/* Changed icon to FaChartLine */}

            {/* <NavLink onClick={() => setSidebarOpen(false)} to="Training"><li><FaTrain /><span>Training Portal</span></li></NavLink> */}
          </ul>
        </div>

        <div className={`content ${isMobile && sidebarOpen ? 'blurred' : ''}`}>
          <Outlet />
        </div>
      </div>

      {isMobile && sidebarOpen && (
        <div className="overlay" onClick={() => setSidebarOpen(false)} />
      )}
    </div>
  );
}